import {createTransformer, ITransformer} from 'mobx-utils';

export type VisualArtifactRefId = string;
export type VisualArtifactRefDescriptor = string;

export interface IVisualArtifactRefSnapshot
{
    organization:string;
    name:string;
    version:string;
}

export class VisualArtifactRef
{
    public readonly organization:string;

    public readonly name:string;

    public readonly version:string;

    public constructor(organization:string, name:string, version:string)
    {
        this.organization = organization;
        this.name = name;
        this.version = version;
    }

    public get id():VisualArtifactRefId
    {
        return VisualArtifactRef.makeId(this.organization, this.name);
    }

    public static makeId(organization:string, name:string):VisualArtifactRefId
    {
        return `${organization}:${name}`;
    }

    public get fullId():VisualArtifactRefDescriptor
    {
        return `${this.organization}:${this.name}:${this.version}`;
    }

    public static toJson:ITransformer<VisualArtifactRef, IVisualArtifactRefSnapshot> = createTransformer((visualArtifactRef:VisualArtifactRef) =>
    {
        return {
            organization: visualArtifactRef.organization,
            name: visualArtifactRef.name,
            version: visualArtifactRef.version
        };
    });

    public static fromJson(json:IVisualArtifactRefSnapshot):VisualArtifactRef
    {
        return new VisualArtifactRef(json.organization, json.name, json.version);
    }

    public static fromJsonDeep(json:IVisualArtifactRefSnapshot):VisualArtifactRef
    {
        return VisualArtifactRef.fromJson(json);
    }
}
